export default "__VITE_ASSET__bjBw_3A8__"